export default __webpack_public_path__ + "static/a_love_of_thunder-webfont-927a2f1c6d62af64c0e52384b7e59726.woff2";